import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { createEditorValue } from '@gitbook/doc-core';
import { Document, type DocumentJSON, deserialize, Value } from '@gitbook/slate';

import { BasicEditor } from './BasicEditor';

/**
 * Display a basic document from the API in a non-editable format.
 */
export function BasicDocument(props: {
    document: Value | Document | api.JSONDocument;
    className?: string;
    typographyClassName?: string;
}) {
    const { document, className, typographyClassName } = props;

    const value = React.useMemo(() => {
        if (Value.isValue(document)) {
            return document;
        }

        if (Document.isDocument(document)) {
            return createEditorValue(document, 'basic');
        }

        return createEditorValue(deserialize(document as DocumentJSON), 'basic');
    }, [document]);

    return (
        <BasicEditor
            value={value}
            readOnly
            onChange={() => {}}
            className={className}
            typographyClassName={typographyClassName}
        />
    );
}
